/**
 * @copyright (C) 2024, rsupport. All rights reserved
 *
 * @license
 * This software and/or source code may be used, copied and/or disseminated only
 * with the written permission of rsupport, or in accordance with the terms
 * and conditions stipulated in the agreement/contract under which the software
 * and/or source code has been supplied by rsupport or its affiliates.
 * Unauthorized use, copying, or dissemination of this file, via any medium, is
 * strictly prohibited, and will constitute an infringement of copyright.
 *
 * @author
 * SoonKi Min (skmin@rsupport.com)
 *
 * @description
 *
 * @created at Mon Apr 08 2024
 **/

import { useFileManager } from "@/frameworks/core/hooks";

import { Typography } from "@/frameworks/designStuff/components";
import { Maybe } from "@/frameworks/libraries/components";
import { ChronoUtils, Utility } from "@/frameworks/libraries/utilities";
import { Fragment } from "react";

export default function FileDescriptor({
	file,
	isShare3D
}: {
	file: Required<FileBox.Folders.GetFolderFileListResponse>["content"][number];
	isShare3D?: boolean;
}) {
	const createdDate = new Date(file.createDateTime || 0);
	const typoColor = isShare3D ? "neutral_00_100" : "neutral_50_100";
	const { currentFolder } = useFileManager();
	return (
		<Fragment>
			<Typography typoSize="Body5" align="left" typoColor={typoColor}>
				{ChronoUtils.formatPolicyDateOnly(createdDate.getTime())}
			</Typography>
			<Maybe
				test={currentFolder.folderType === "CHAT" && currentFolder.all}
				fallback={
					<>
						{file.fileBoxType === "FILE" && (
							<Typography typoSize="Body5" typoColor={typoColor}>
								•
							</Typography>
						)}
						{file.fileBoxType === "FILE" && (
							<Typography typoSize="Body5" typoColor={typoColor}>
								{Utility.formatBytes(file.fileSize || 0)}
							</Typography>
						)}
					</>
				}
			></Maybe>
		</Fragment>
	);
}
